import React, { useEffect, useState } from 'react';
// import HeroForm from '../components/HeroForm'; // Replaced with ApplicationFormFields
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';
import { Swiper } from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import ApplicationFormFields from '../components/ApplicationFormFields';
import apiService from '../services/apiService';

const Home = () => {
  // Form state for ApplicationFormFields
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    phone: '',
    course: '2', // Default to MTECH (Master of Technology)
    specialization: '',
    employment_status: ''
  });

  // State for admission closes on date
  const [admissionClosesOn, setAdmissionClosesOn] = useState('14 Sep 2026'); // Default fallback value

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Hero form submitted:', formData);
    alert('Application submitted successfully!');
    // Reset form but keep default course
    setFormData({
      name: '',
      email: '',
      phone: '',
      course: '2', // Keep MTECH as default
      specialization: '',
      employment_status: ''
    });
  };

  // Fetch university courses data to get admission_closes_on
  useEffect(() => {
    const fetchAdmissionDate = async () => {
      try {
        const response = await apiService.getUniversityCourses();
        // API response format: { success: true, data: { university: {...}, courses: [...] } }
        if (response.success && response.data && response.data.success && response.data.data && response.data.data.university && response.data.data.university.admission_closes_on) {
          setAdmissionClosesOn(response.data.data.university.admission_closes_on);
        } else if (response.success && response.data && response.data.university && response.data.university.admission_closes_on) {
          // Fallback for different response structure
          setAdmissionClosesOn(response.data.university.admission_closes_on);
        }
      } catch (error) {
        console.error('Error fetching admission date:', error);
        // Keep default value on error
      }
    };

    fetchAdmissionDate();
  }, []);

  useEffect(() => {
    // Initialize Student Services Swiper
    const initStudentServicesSwiper = () => {
      const swiperElement = document.querySelector('.student-services-swiper');
      if (swiperElement && !swiperElement.swiper) {
        new Swiper(swiperElement, {
          modules: [Pagination, Autoplay],
          loop: true,
          speed: 600,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          slidesPerView: 'auto',
          spaceBetween: 20,
          pagination: {
            el: '.student-services-swiper .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 20
            }
          }
        });
      }
    };

    // Initialize Specialized Programs Swiper
    const initSpecializedProgramsSwiper = () => {
      const swiperElement = document.querySelector('.specialized-programs-swiper');
      
      if (swiperElement && !swiperElement.swiper) {
        try {
          new Swiper(swiperElement, {
            modules: [Pagination, Autoplay],
            loop: true,
            speed: 1500,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            pagination: {
              el: '.specialized-programs-swiper .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 1,
                spaceBetween: 40
              },
              1200: {
                slidesPerView: 2,
                spaceBetween: 20
              }
            }
          });
        } catch (error) {
          console.error('Error initializing Specialized Programs Swiper:', error);
        }
      }
    };

    // Initialize Top Recruiters Swiper
    const initTopRecruitersSwiper = () => {
      const swiperElement = document.querySelector('.top-recruiters-swiper');
      
      if (swiperElement && !swiperElement.swiper) {
        try {
          new Swiper(swiperElement, {
            modules: [Pagination, Autoplay],
            loop: true,
            speed: 600,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 8,
            pagination: {
              el: '.top-recruiters-swiper .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            breakpoints: {
              320: {
                slidesPerView: 3,
                spaceBetween: 3
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 5
              },
              1200: {
                slidesPerView: 7,
                spaceBetween: 8
              }
            }
          });
        } catch (error) {
          console.error('Error initializing Top Recruiters Swiper:', error);
        }
      }
    };

    // Initialize after a short delay to ensure DOM is ready
    const swiperTimer = setTimeout(() => {
      initStudentServicesSwiper();
      initSpecializedProgramsSwiper();
      initTopRecruitersSwiper();
    }, 500);

    return () => {
      clearTimeout(swiperTimer);
    };
  }, []);

  return (
    <>
      
      {/* Hero Section */}
      <section id="hero" className="hero section gredient-background">
        <div className="container">
          <div className="row gy-4 justify-content-center justify-content-lg-between">
            <div className="col-lg-7 order-2 order-lg-1 d-flex flex-column justify-content-center">
              <span data-aos="fade-up" className="top-txt textprimary d-inline-block fs-14 bg-opacity-10 px-3 py-1 rounded-pill mb-3 border fw-semibold">
                Engineers build the nation
              </span>
              
              <h1 className="d-none d-md-block" data-aos="fade-up">
                B.Tech Lateral Entry For Working Professionals In Flexible Time Shifts.
              </h1>
              
              <p data-aos="fade-up" data-aos-delay="100">
                Advance your career with a flexible, industry-oriented B.Tech Lateral Entry program from Mewar University. 
                Designed to fit your schedule, this program helps you upgrade your skills and stay ahead in today's fast-evolving technology landscape. 
                Enroll now in UGC-approved programs.
              </p>
              
              <div className="admcol bg-warning bg-opacity-25 textprimary py-2 px-3 px-lg-4 border fw-semibold d-inline-flex align-items-center gap-1 rounded-pill mb-4 shadow" data-aos="fade-up" data-aos-delay="200">
                <i className="bi bi-mortarboard mx-1"></i>
                <p className="mb-0 mt-0 admclose">
                  {admissionClosesOn}
                </p>
              </div>
              
              <div className="d-flex" data-aos="fade-up" data-aos-delay="200">
                <button 
                  className="btn-get-started"
                  onClick={() => {
                    // Dispatch custom event to trigger global modal
                    window.dispatchEvent(new CustomEvent('showApplicationModal'));
                  }}
                >
                  Apply Now
                </button>
                <button 
                  className="btn-watch-video d-flex align-items-center"
                  onClick={() => {
                    // Dispatch custom event to trigger global modal
                    window.dispatchEvent(new CustomEvent('showApplicationModal'));
                  }}
                >
                  <span>Get free Counselling</span> <i className="bi bi-headset mx-1"></i>
                </button>
              </div>
            </div>
            
            <div className="col-lg-4 order-1 order-lg-2 hero-img" data-aos="zoom-out">
              <h1 className="d-sm-block d-md-none mb-4" data-aos="fade-up">
              B.Tech Lateral Entry For Working Professionals In Flexible Time Shifts.
              </h1>
              <div className="hero-form">
                <div className="text-center px-3 p-px-4 pt-1">
                  <h5 className="fw-bold mb-0 textprimary">B.Tech Lateral Entry Program</h5>
                </div>
                <div className="form-wrapper">
                  <ApplicationFormFields 
                    formData={formData}
                    onInputChange={handleInputChange}
                    onSubmit={handleSubmit}
                    submitButtonText="Apply Now"
                    showPrivacyNote={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      
        {/* Explore Section */}
        <section id="explore" className="explore section">
        <div className="container section-title aos-init aos-animate" data-aos="fade-up">
          <h2>Explore<br /></h2>
          <p><span>Step Into Excellence with </span> <span className="description-title">Modern Facilities and Superior Education</span></p>
        </div>
        
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4">
            <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="explore-item">
                <div className="item p-3 shadow-sm rounded bg-light border">
                  <div className="worldImg mb-4">
                    <img src="/assets/img/icon/icon-1.png" alt="pedagogy Icon" className="w-25" />
                  </div>
                  <h6 className="mb-3 fw-bold">Expert Faculty Teaching</h6>
                  <p className="text-secondary fs-13">More than educators, our faculty serve as mentors, advisors, and experts from the field</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="explore-item">
                <div className="item p-3 shadow-sm rounded bg-light border">
                  <div className="worldImg mb-4">
                    <img src="/assets/img/icon/icon-2.png" alt="campus Icon" className="w-25" />
                  </div>
                  <h6 className="mb-3 fw-bold">Modern Campus with Advanced Amenities</h6>
                  <p className="text-secondary fs-13">Beyond classrooms, our campus is a hub of creativity and innovation.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="400">
              <div className="explore-item">
                <div className="item p-3 shadow-sm rounded bg-light border">
                  <div className="worldImg mb-4">
                    <img src="/assets/img/icon/icon-3.png" alt="activities Icon" className="w-25" />
                  </div>
                  <h6 className="mb-3 fw-bold">Dynamic Student Activities</h6>
                  <p className="text-secondary fs-13">Campus life at Mewar University blends culture, sports, and student clubs into a truly vibrant experience.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay="500">
              <div className="explore-item">
                <div className="item p-3 shadow-sm rounded bg-light border">
                  <div className="worldImg mb-4">
                    <img src="/assets/img/icon/icon-4.png" alt="Industry Icon" className="w-25" />
                  </div>
                  <h6 className="mb-3 fw-bold">Practical, Career-Oriented Learning</h6>
                  <p className="text-secondary fs-13">Engage with industry leaders to turn classroom learning into practical experience.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about section">
        <div className="container section-title" data-aos="fade-up">
          <h2>University Focus<br /></h2>
          <p>
            <span>Key Highlights of</span> <span className="description-title">Mewar University</span>
          </p>
        </div>

        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="100">
              <img src="/assets/img/mewar-banner.jpg" className="img-fluid mb-4 aboutkey-img" alt="" />
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay="250">
              <div className="content ps-0 ps-lg-5">
                <p className="fst-italic">
                  Mewar University, established in 2009 by the Government of Rajasthan, is a UGC-recognized and NAAC-accredited autonomous university. 
                  It is the only private, self-financed university in Rajasthan approved under UGC 12B, and is a member of AIU with approvals from AICTE, PCI, BCI, IAP, NCC, NSS, and NCTE.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>Established in 2009, Mewar University, Rajasthan, is a UGC-approved, student-centric institution attracting learners from across the country.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>Founded in 2009 by the Government of Rajasthan through Act No. 4 of 2009.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>To empower people with the skills that contribute to professional success, Mewar University has implemented a unique two way teaching learning practice since its inception</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>University provides the opportunity to discuss personal issues causing distress and gain clarity with the guidance of a trained counselor.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>Training begins with formal education and extends to mentoring candidates with industry-relevant skills.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>Our University and Training Partners work tirelessly to ensure students are placed in their desired careers.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Programs Section */}
      <SpecializedPrograms />

       {/* Top Recruiters Section */}
       <section id="recruiters" className="recruiters section dark-background">
        <img className="rectubg" src="/assets/img/stats-bg.jpg" alt="" data-aos="fade-in" />
        <div className="container section-title" data-aos="fade-up">
          <p><span>Top Recruiters</span></p>
        </div>
        
        <div className="container position-relative" data-aos="fade-up" data-aos-delay="100">
          <div className="swiper top-recruiters-swiper">
            <div className="swiper-wrapper align-items-center recuterslide mb-5">
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/GENPACT.png" className="img-fluid" alt="GENPACT" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/infosys.png" className="img-fluid" alt="infosys" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/it mint.png" className="img-fluid" alt="it mint" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/jindal steel and power.png" className="img-fluid" alt="jindal steel and power" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/JIO.png" className="img-fluid" alt="JIO" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/LG.png" className="img-fluid" alt="LG" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/NEXT WEALTH.png" className="img-fluid" alt="NEXT WEALTH" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/ntpc.png" className="img-fluid" alt="ntpc" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/tatamoters.png" className="img-fluid" alt="tata moters" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/TCSION.png" className="img-fluid" alt="TCS ION" /></div>
              </div>
              <div className="swiper-slide">
                <div className="rectcol"><img src="/assets/img/top-recruiters/techmahindra.png" className="img-fluid" alt="tech mahindra" /></div>
              </div>
            </div>
            <div className="swiper-pagination"></div>
          </div>
        </div>
      </section>

      {/* Sample Certificate Section */}
      <section id="sample-certificate" className="sample-certificate section light-background">
        <div className="container" data-aos="fade-up">
          <div className="row gy-4">
            <div className="col-lg-4 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
              <img src="/assets/img/sample-certificate.jpg" className="img-fluid mb-4" alt="" />
            </div>
            <div className="col-lg-8 aos-init aos-animate" data-aos="fade-up" data-aos-delay="250">
              <div className="section-title aos-init aos-animate">
                <p>Flexible B.Tech for Working Professionals, offered by Mewar University</p>
              </div>
              <div className="samplecontent content ps-0 ps-lg-5">
                <p className="fst-italic">
                  The B.Tech Lateral Entry program at Mewar University is designed for working professionals, 
                  providing e-lectures, one-on-one academic support, career guidance, and additional resources.
                </p>
                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>LMS Access to easily track your learning progress.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>State-of-the-art Laboratories for hands-on experiments.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>Dedicated Faculty Support available whenever needed.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>24/7 Placement Assistance to guide your career journey.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill"></i> 
                    <span>Expert-led Training Sessions & Masterclasses for advanced learning.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Celebrating Achievements Section */}
      <CelebratingAchievements />

     {/* Student Services Section */}
     <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />
    </>
  );
};

export default Home;
